import { useContext } from 'react';
import { Box, Center, Divider, Flex, Image, LoadingOverlay, Space } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { EmailBoxContext } from '../../Service/Context/EmailBoxContext';
import SkeletonItems from '../../Atoms/SkeletonItems';
import PaginationNav from '../../Molecules/Navigation/PaginationNav';
import EmailMasterDetail from '../../Templates/Emails/EmailMasterDetail';
import ChatMessage from '../../Molecules/Message/ChatMessage';
import { MessageContext } from '../../Service/Context/MessageContextV2';
import { useEventScope } from '../../Service/hooks/useEventScope';
import ChatMessagePreview from './ChatMessagePreview';
import NewEmail from './NewEmail';
import EmailRowPhone from './EmailRowPhone';
import EmailsListHeader from './EmailsListHeader';
import ReplyMessagePreview from './ReplyMessagePreview';

const EmailsSection = () => {
  const { loading, messages, pageNumber, pageCount, totalCount, setPageNumber, selectedMessage, isBookitupScope } =
    useContext(EmailBoxContext);
  const { preparingMessage } = useContext(MessageContext);
  const isDesktop = useMediaQuery('(min-width: 1200px)');
  const emptyBox = messages.length === 0;

  return (
    <Box pos="relative">
      <LoadingOverlay visible={preparingMessage} overlayBlur={2} loaderProps={{ size: 'xl' }} />
      {isDesktop ? (
        <DesktopSection />
      ) : (
        <>
          <EmailsListHeader phoneVersion />
          {!selectedMessage && (
            <>
              {loading && <SkeletonItems mt="sm" count={8} height={100} />}
              {!loading && messages.map((email) => <EmailRowPhone key={email.id} email={email} />)}
              {emptyBox && (
                <Center mt="10rem">
                  <Image width={192} src="/img/redpanda-inbox.svg" caption="Keine E-Mails" />
                </Center>
              )}
            </>
          )}
          {selectedMessage && <ChatMessage phoneVersion />}
          {!selectedMessage && !emptyBox && (
            <Center>
              <PaginationNav
                pageSize={10}
                pageNumber={pageNumber}
                totalCount={totalCount}
                totalPages={pageCount}
                onChange={(newPageNumber) => setPageNumber(newPageNumber - 1)}
                entityName="Nachricht"
                disabled={!isBookitupScope && loading}
              />
            </Center>
          )}
        </>
      )}
    </Box>
  );
};

const DesktopSection = () => {
  const { action } = useContext(MessageContext);
  const replying = action === 'REPLY';
  const { isEventScope } = useEventScope();

  return (
    <Flex gap="xs" sx={{ minHeight: '100vh' }}>
      <Box sx={{ width: isEventScope ? '35%' : '40%', maxWidth: 500, flexShrink: 0 }}>
        <EmailMasterDetail />
      </Box>
      <Divider orientation="vertical" />
      <Box sx={{ flexGrow: 1, maxWidth: '100%', minWidth: 0 }}>
        <NewEmail />
        <ChatMessagePreview />
        {replying && (
          <>
            <Space h="xl" />
            <ReplyMessagePreview withPadding />
          </>
        )}
      </Box>
    </Flex>
  );
};

export default EmailsSection;
